export default __webpack_public_path__ + "static/Hush_Puppies-033a5cc9d6ac81c2063a2af5df136bf7.png";